import IconButton from '@components/v2/ui/IconButton/IconButton';
import { Box, Collapse, Stack } from '@mui/material';
import { ChevronDown, ChevronUp } from 'lucide-react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import OrderConditionSplitLabel from '../../../../../conditions/components/OrderConditionSplitLabel';
import { OrderCondition } from '../../../../../conditions/interfaces/orderCondition.interface';
import {
  getConditionAvailability,
  getConditionSplitLabelParts,
} from '../../../../../conditions/orderCondition.utils';
import { BusinessPolicyViolationView } from '../businessPolicyViolation.types';
import { useBusinessPolicyViolationConditionSection } from '../hooks/useBusinessPolicyViolationConditionSection';
import BusinessPolicyViolationDetails from './BusinessPolicyViolationDetails';

interface BusinessPolicyViolationConditionSectionProps {
  condition: OrderCondition;
  violations: BusinessPolicyViolationView[];
}

const BusinessPolicyViolationConditionSection = ({
  condition,
  violations,
}: BusinessPolicyViolationConditionSectionProps) => {
  const { translate } = useTranslation();
  const { isExpanded, toggleExpanded } = useBusinessPolicyViolationConditionSection();

  return (
    <Stack>
      <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5 }}>
        <Box onClick={toggleExpanded} sx={{ flex: 1, minWidth: 0, cursor: 'pointer' }}>
          <OrderConditionSplitLabel
            availability={getConditionAvailability(condition.orderType)}
            {...getConditionSplitLabelParts(condition, translate)}
          />
        </Box>
        <IconButton
          icon={isExpanded ? ChevronUp : ChevronDown}
          size="medium"
          ariaLabel={translate(LangEnum.GLOBAL_SECTION_TOGGLE)}
          ariaExpanded={isExpanded}
          onClick={toggleExpanded}
        />
      </Stack>

      <Collapse in={isExpanded}>
        <Box sx={{ pt: 2 }}>
          <BusinessPolicyViolationDetails violations={violations} />
        </Box>
      </Collapse>
    </Stack>
  );
};

export default BusinessPolicyViolationConditionSection;
